import React from "react";
import { Modal } from "react-bootstrap";

import PayrollIntegratedACHDisclaimer from "./PayrollIntegratedACHDisclaimer";

interface Props {
  show: boolean;
  onClose: () => void;
  onClick?: () => void;
}

class PayrollIntegratedACHDisclaimerModal extends React.PureComponent<Props> {
  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <Modal
        centered
        scrollable
        show={this.props.show}
        onHide={this.props.onClose}
        size="lg"
        className="payroll-ach-disclaimer-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>ACH Authorization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PayrollIntegratedACHDisclaimer
            onClick={this.props.onClick}
            btnLabel="Continue"
            fromModal={true}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default PayrollIntegratedACHDisclaimerModal;
